import { createSolanaWalletProvider, unwrapSolanaProviderRequest, } from '@farcaster/frame-core';
import { frameHost } from "./frameHost.js";
const { solanaProviderRequest } = frameHost;
let solanaProvider;
if (solanaProviderRequest) {
    solanaProvider = createSolanaWalletProvider(unwrapSolanaProviderRequest(solanaProviderRequest));
}
async function getSolanaProvider() {
    let capabilities;
    try {
        capabilities = await frameHost.getCapabilities();
    }
    catch { }
    if (!capabilities?.includes('wallet.getSolanaProvider')) {
        return undefined;
    }
    return solanaProvider;
}
export { getSolanaProvider };
